import React, { useContext } from 'react';

//components
import WidgetButton from './WidgetButton/WidgetButton';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';

//context
import { ListContext } from '@/context/ListContext'



const PageWidget = () => {

    const {listId, appGuid, isMainMenu} = useContext(ListContext)

    return (
        <div className="widget-panel-item">
            <WidgetButton type={WidgetType.PAGE} href={`/a/${appGuid}/Content?parentId=${listId}&contentType=Page&position=${isMainMenu ? 'end' : 'start'}`} />

        </div>
    )
}
export default PageWidget